
export default function CoursePricing(props){

    const id = props.match.params.id;

    window.location.href = `/app/courses/${id}/enroll`;
    
    return <></>

}

